import "./CarouselBars.css";

import type { CSSProperties } from "react";

/** Renders the accessible progress controls shared by timed carousels. */
export function CarouselBars({
  items,
  index,
  running,
  cycleMs,
  onPick,
  onCycleEnd,
  label,
  className = "",
}: {
  items: string[];
  index: number;
  running: boolean;
  cycleMs: number;
  onPick: (i: number) => void;
  onCycleEnd: () => void;
  label: string;
  className?: string;
}) {
  return (
    <div role="tablist" aria-label={label} className={`carousel-bars flex gap-2 ${className}`}>
      {items.map((name, i) => (
        <button
          key={name + i}
          type="button"
          role="tab"
          aria-selected={i === index}
          aria-label={name}
          onClick={() => onPick(i)}
          className="carousel-bars__button group/bar relative flex-1 -my-3 py-3"
        >
          <span className="carousel-bars__track relative block h-1.5 w-full overflow-hidden rounded-full bg-zinc-200">
            {i < index && <span className="carousel-bars__past absolute inset-0 rounded-full" />}
            {i === index &&
              (running ? (
                <span
                  key={index}
                  className="carousel-bars__fill bar-fill absolute inset-0 origin-left rounded-full bg-dec-green"
                  style={{ "--bar-ms": `${cycleMs}ms` } as CSSProperties}
                  onAnimationEnd={onCycleEnd}
                />
              ) : (
                <span className="carousel-bars__fill absolute inset-0 rounded-full bg-dec-green" />
              ))}
          </span>
        </button>
      ))}
    </div>
  );
}
